import { DocumentRenderer } from '@keystone-6/document-renderer';
import type { GetServerSidePropsContext, NextPage } from 'next';
import Container from '../components/container/container.component';
import NoLatestNews from '../components/latest-news/no-latest-news/no-latest-news.component';
import SectionTitle from '../components/section-title/section-title.component';
import { getPostsListByCategory } from '../lib';
import styles from '../styles/team.module.scss';
import Page from '../templates/page.template';
import { TeamProps } from '../types/team-props.interface';

interface Props extends TeamProps { }

const TeamPage: NextPage<Props> = ({ menu, options, team }) => (
  <Page
    menu={menu}
    options={options}
    title="Team"
    description={options.description}
  >
    <Container column={true}>
      <SectionTitle title="Team" />
      {team.length ? (
        <div
          className={styles.content}
          style={{ display: 'flex', flexWrap: 'wrap' }}
        >
          {team.map((member) => (
            <div key={member.id} className={styles.detailsWrapperHalfWidth}>
              <div className={styles.teamImageWrapper}>
                <img
                  src={`${options.baseUrl}${member.image.url}`}
                  alt="alt"
                  className={styles.img}
                />
              </div>
              <div className={styles.teamTextWrapper}>
                <h2>{member.title}</h2>
                <div>
                  <DocumentRenderer document={member.content.document} />
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ width: '100%', maxWidth: '1200px', margin: 'auto' }}>
          <NoLatestNews category="team" />
        </div>
      )}
    </Container>
  </Page>
);

export async function getServerSideProps(props: GetServerSidePropsContext) {
  const { menu, options, posts } = await getPostsListByCategory(
    'team',
    0,
    10000
  );

  props.res.setHeader('Cache-Control', 'public, max-age=300, s-maxage=300');

  return { props: { menu, options, team: posts } };
}

export default TeamPage;
